import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VIcons } from '@/shared/ui'
import { h } from 'vue'
import { DEFAULT_APP_LOCALE } from '@/shared/lib/i18n'
import { en, kz, rs, ru } from './locale'
import colors from 'vuetify/util/colors'
import { aliases as mdAliases } from 'vuetify/iconsets/md'

const VuetifyConfig = createVuetify({
  components,
  directives,

  locale: {
    locale: DEFAULT_APP_LOCALE,
    fallback: 'en',
    messages: { ru, en, kz, rs },
  },

  icons: {
    defaultSet: 'mdio',
    aliases: {
      ...mdAliases,
      success: 'check_circle',
      info: 'info',
      warning: 'warning',
      error: 'error',
    },
    sets: {
      mdio: {
        component: (props: any) => h<any>(VIcons, props),
      },
    },
  },

  defaults: {
    VBtn: {
      variant: 'flat',
      color: 'primary',
      class: 'text-none',
      style: {
        'letter-spacing': 'normal',
        'font-weight': 400,
        'font-size': '16px',
      },
    },
    VListItem: {
      style: {
        'min-height': '36px',
      },
    },
    VListItemTitle: {
      style: {
        'font-size': '14px',
      },
    },
    VTextField: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      clearIcon: 'close',
      autocomplete: 'off',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      autocomplete: 'off',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      menuIcon: 'keyboard_arrow_down',
      clearIcon: 'close',
      autocomplete: 'off',
    },
    VSelect: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      menuIcon: 'keyboard_arrow_down',
      clearIcon: 'close',
      autocomplete: 'off',
    },
    VToolbar: {
      style: {
        'background-color': 'white',
      },
    },
    VDialog: {
      VCard: {
        VCardText: {
          style: {
            padding: '0',
          },
        },
      },
    },
    VBreadcrumbs: {
      density: 'compact',
    },
    VTabs: {
      density: 'compact',
      prevIcon: 'chevron_left',
      nextIcon: 'chevron_right',
    },
    VDataTable: {
      sortAscIcon: 'arrow_upward',
      sortDescIcon: 'arrow_downward',
      firstIcon: 'keyboard_double_arrow_left',
      lastIcon: 'keyboard_double_arrow_right',
      nextIcon: 'chevron_right',
      prevIcon: 'chevron_left',
    },
    VDataTableServer: {
      sortAscIcon: 'arrow_upward',
      sortDescIcon: 'arrow_downward',
      firstIcon: 'keyboard_double_arrow_left',
      lastIcon: 'keyboard_double_arrow_right',
      nextIcon: 'chevron_right',
      prevIcon: 'chevron_left',
    },
    VExpansionPanels: {
      collapseIcon: 'keyboard_arrow_up',
      expandIcon: 'keyboard_arrow_down',
    },
    VCheckbox: {
      falseIcon: 'check_box_outline_blank',
      density: 'compact',
      trueIcon: h<any>(VIcons, {
        type: 'check_box',
        bold: true,
      }),
      indeterminateIcon: 'chips',
      color: 'primary',
    },
    VCheckboxBtn: {
      falseIcon: 'check_box_outline_blank',
      density: 'comfortable',
      trueIcon: h<any>(VIcons, {
        type: 'check_box',
        bold: true,
      }),
      indeterminateIcon: 'chips',
      color: 'primary',
    },
    VRadioGroup: {
      color: 'primary',
      density: 'comfortable',
      falseIcon: 'radio_button_unchecked',
      trueIcon: 'radio_button_checked',
    },
    VChip: {
      closeIcon: 'close',
    },

    VFileInput: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      prependIcon: 'attach_file_add',
      clearIcon: 'close',
      autocomplete: 'off',
    },
    VTreeview: {
      expandIcon: 'arrow_right',
      collapseIcon: 'arrow_drop_down',
      indeterminateIcon: h<any>(VIcons, {
        type: 'chips',
        bold: true,
      }),

      VBtn: {
        ripple: false,
      },
    },
    VDateInput: {
      variant: 'outlined',
      prependIcon: '',
      nextIcon: 'keyboard_arrow_right',
      prevIcon: 'keyboard_arrow_left',
      modeIcon: 'arrow_drop_down',
      appendInnerIcon: 'calendar_month',
      VDatePicker: {
        color: 'primary',
        VBtn: {
          color: 'black',
        },
      },
    },
  },

  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1976d2',
          secondary: colors.green.darken1,
          warning: colors.yellow.darken2,
        },
        variables: {
          'btn-height': '40px',
        },
      },
    },
  },
})

export default VuetifyConfig
